import __request__ from "routing/request";
export function updateConfig(requestOptions) {
  return __request__("PUT", "/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
